import ActionTypes from '../constants/ActionTypes'; 

const initialState = {
    loading: false,
    data: {},
    error: null,
};

const confirmCameraCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FETCH_CONFIRM_CAMERA_COUNT_REQUEST:
            return { ...state, loading: true };
        case ActionTypes.FETCH_CONFIRM_CAMERA_COUNT_SUCCESS:
            return { ...state, loading: false, data: action.payload};
        case ActionTypes.FETCH_CONFIRM_CAMERA_COUNT_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default confirmCameraCountReducer;
